import React, { useState, useEffect } from "react";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { i18n } from "../../translate/i18n";
import useBuscaSelecaoMultipla from "../../hooks/useBuscaSelecaoMultipla";

// Fechado, o campo não mostra chips: o resumo no placeholder é o que avisa que há
// etapa desmarcada. Nenhuma marcada não é "todas" — a aba Contatos fica vazia.
const resumoEtapas = (marcadas, total) => {
  if (total > 0 && marcadas >= total) return `Todas (${total})`;
  if (marcadas === 0) return "Nenhuma";
  return `${marcadas} de ${total}`;
};

const TicketsQueueSelect = ({ userQueues, selectedQueueIds = [], onChange }) => {
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    setSelectedValues(userQueues.filter(queue => selectedQueueIds.includes(queue.id)));
  }, [selectedQueueIds, userQueues]);

  const handleChange = (event, newValue) => {
    // Verifica se "Selecionar Tudo" foi clicado
    if (newValue.some((option) => option.id === "toggle-all")) {
      if (selectedQueueIds.length === userQueues.length) {
        setSelectedValues([]);
        onChange([]);
      } else {
        setSelectedValues(userQueues);
        onChange(userQueues.map((queue) => queue.id));
      }
    } else {
      setSelectedValues(newValue);
      onChange(newValue.map((queue) => queue.id));
    }
  };

  // Mantém o texto da busca ao marcar itens (o MUI limpa por padrão).
  const busca = useBuscaSelecaoMultipla();

  return (
    <Autocomplete
      multiple
      options={[{ id: "toggle-all", name: "Selecionar Tudo" }, ...userQueues]}
      getOptionLabel={(option) => option.name}
      value={selectedValues}
      disableCloseOnSelect
      {...busca}
      onChange={handleChange}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      ListboxProps={{
        style: {
          maxHeight: 300,
          overflowY: 'auto',
          fontSize: '0.85rem',
        },
      }}
      sx={{
        fontSize: '0.85rem',
        '& .MuiAutocomplete-inputRoot': {
          padding: '4px !important',
          fontSize: '0.85rem',
        },
      }}
      renderTags={() => null} // remove a exibição dos chips
      renderOption={(props, option, { selected }) => (
        <MenuItem
          {...props}
          dense
          sx={{
            fontSize: '0.85rem',
            minHeight: '32px',
            paddingY: 0.5,
          }}
        >
          <Checkbox
            color="primary"
            checked={
              option.id === "toggle-all"
                ? selectedQueueIds.length === userQueues.length
                : selected
            }
            indeterminate={
              option.id === "toggle-all" &&
              selectedQueueIds.length > 0 &&
              selectedQueueIds.length < userQueues.length
            }
            sx={{
              padding: '4px',
              '& svg': { fontSize: '18px' },
            }}
            style={{ color: option.color || "inherit" }}
          />
          <ListItemText
            primary={option.name}
            primaryTypographyProps={{ fontSize: '0.85rem' }}
          />
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={i18n.t("ticketsQueueSelect.placeholder")}
          variant="outlined"
          margin="dense"
          InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
          placeholder={resumoEtapas(selectedQueueIds.length, userQueues.length)}
          sx={{
            '& input': {
              fontSize: '0.85rem',
            },
            '& label': {
              fontSize: '0.85rem',
            },
          }}
        />
      )}
    />

  );
};

export default TicketsQueueSelect;
